<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="hxSkuCode"
      resizable
      auto-resize
      highlight-hover-row
      :data="tableData"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :loading="loading"
      :height="700"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{
        highlight: true,
        reserve: true,
      }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
      @cell-click="cellClick"
    >
      <template v-slot:toolbar_form>
        <slot name="header" />
      </template>
      <template v-slot:pager>
        <slot name="pager" />
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="opt.disabled ? opt.disabled(row) : false"
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic-square.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic-square.jpg',
          ]"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic-square.jpg"
              style="width:60px; height:60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:displayName="{ row }">
        <span>{{ row.goodsName }}</span>
        <br />
        <span>{{ row.goodsNameEn }}</span>
        <br />
        <span>SKU:</span><span style="color: #409EFF">{{ row.hxSkuNo }}</span>
      </template>
      <template v-slot:displayBrand="{ row }">
        <span style="color: #303133">{{ row.brandName }}</span>
        <br />
        <span style="color: #303133">{{ row.categoryFullName }}</span>
        <br />
        <span style="color: #303133">{{ row.collectionName }}</span>
      </template>
      <template v-slot:displayColor="{ row }">
        <span style="color: #303133">{{ row.goodsSize }}</span>
        <br />
        <span style="color: #303133"
          >{{ row.goodsColor }} &nbsp; {{ row.goodsColorEn }}</span
        >
        <br />
        <span style="color: #303133">{{ row.goodsPattern }}</span>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.hxSkuStatus === 'D'
              ? 'danger'
              : row.hxSkuStatus === 'Q'
              ? 'light'
              : 'success'
          "
        >
          {{ row.v_hxSkuStatus }}
        </el-tag>
        <el-tag
          v-if="row.v_applicationStatus && row.applicationStatus !== 'M'"
          size="mini"
          class="ml-2"
          effect="plain"
          :type="
            row.applicationStatus === 'R'
              ? 'danger'
              : row.applicationStatus === 'P'
              ? 'light'
              : 'success'
          "
        >
          {{ row.v_applicationStatus }}
        </el-tag>
        <div v-if="row.rejectReason" style="color:red" class="mt-2">
          {{ row.rejectReason }}
        </div>
      </template>
      <template v-slot:isVc="{ row }">
        <el-tag
          size="mini"
          v-if="row.isVc"
          :type="row.isVc === 'N' ? 'info' : 'warning'"
        >
          {{ row.v_isVc }}
        </el-tag>
      </template>
      <template v-slot:displayFactory="{ row }">
        <span>NC:</span><span style="color: #303133">{{ row.ncNo }}</span>
        <br />
        <span style="color: #303133">{{ row.scmName }}</span>
      </template>
      <template v-slot:displayUnit="{ row }">
        <span>UNIT:</span>
        <span style="color: #303133">
          {{ row.unitLength }}x{{ row.unitWidth }}x{{ row.unitHeight }}cm
        </span>
        <br />
        <span>N.W:</span>
        <span style="color: #303133">{{ row.goodsWeight }} kg</span>
        <br />
        <span>G.W:</span>
        <span style="color: #303133">{{ row.unitWeight }} kg</span>
        <br />
        <span>CBM:</span>
        <span style="color: #303133">{{ row.unitCbm }} m³</span>
      </template>
      <template v-slot:displayBox="{ row }">
        <span>
          CTN:{{ row.ctnLength }}x{{ row.ctnWidth }}x{{ row.ctnHeight }}cm
        </span>
        <br />
        <span>N.W:{{ row.ctnNetWeight }} kg</span>
        <br />
        <span>G.W:{{ row.ctnGrossWeight }} kg</span>
        <br />
        <span>CBM:{{ row.ctnCbm }} m³</span>
      </template>
      <template v-slot:designAndBuyer="{ row }">
        <span>PM：</span>
        <span style="color: #303133">{{ row.designName }}</span>
        <br />
        <span>PC：</span>
        <span style="color: #303133">{{ row.buyerName }}</span>
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
export default {
  mixins: [EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkbox-change', [])
    },
    cellClick({ row, column }) {
      if (this.disabled) return
      const { property } = column
      const filterColumns = ['checkbox', 'col-opt', 'defaultImageUrl']
      if (filterColumns.includes(property)) return

      const $table = this.$refs.table
      $table.toggleCheckboxRow(row)

      const data = $table
        .getCheckboxRecords(true)
        .concat($table.getCheckboxReserveRecords(true))
      this.$emit('checkbox-change', data)
    },
    optCommand({ opt, data }) {
      const { menuType } = opt
      if (!menuType) return

      switch (menuType) {
        case 'detail':
        case 'edit':
        case 'copy':
          this.$emit('openEdit', { type: menuType, data })
          break
        case 'delete':
          this.del(data)
          break
        case 'fullMember':
          this.$emit(menuType, [data.hxSkuCode])
          break
        default:
          console.error('menuType configuration error: ', menuType)
      }
    },
    async del({ hxSkuCode }) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return

      const res = await this.$api
        .ecomHxSkuDelApi({ hxSkuCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
  },
}
</script>
